import { error } from "node:console";
import {
  DELETE_MERCHANT_LOADING,
  DELETE_MERCHANT_SUCCESS,
  DELETE_MERCHANT_FAILED,
  DELETE_MERCHANT_RESET,
} from "../types";

const initialState = {
  deletedMerchant: null,
  loading: false,
  error: null,
  success: false,
};

export const removeMerchantReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DELETE_MERCHANT_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case DELETE_MERCHANT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        deletedMerchant: action.payload,
        success: true,
      };
    case DELETE_MERCHANT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to delete merchant",
        deletedMerchant: null,
        success: false,
      };
    case DELETE_MERCHANT_RESET:
      return initialState;

    default:
      return state;
  }
};
